import {
  Observable,
  Subscription,
  throwError as observableThrowError,
} from 'rxjs';

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { catchError, filter, map, take } from 'rxjs/operators';
import { AppState, Configurations, WatchlistItemConfig } from 'src/app';
import { NotificationService } from 'src/core/services/notification.service';
import { ApiGatewayService } from 'src/shared';
@Injectable()
export class WatchlistService {
  public dataDetail: any[] = [];
  private intervalTimeOut: number = 30 * 1000;
  private loggedInSubscription: Subscription;
  private managementrUrl = 'api/Market/';
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;

  constructor(
    private store: Store<AppState>,
    private apiGatewayService: ApiGatewayService,
    private notificationService: NotificationService,
    private configurations: Configurations,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(
        filter((mapShadowed) => Map.isMap(mapShadowed)),
        map((mapShadowed) => mapShadowed.get('api')),
        take(1),
      )
      .subscribe(
        (api: string) => (this.gbmAPI = api.concat(this.managementrUrl)),
      );

    this.init();
  }

  init(): void {
    this.loggedInSubscription = this.store
      .select('loggedIn')
      .subscribe((value: boolean) => {
        if (value) {
          this.intervalTimeOut =
            +this.configurations.appConfiguration.timeOuts.timeOut30Seg;
        }
      });
  }
  getWatchList(): Observable<any> {
    return this.apiGatewayService.get(`${this.gbmAPI}GetWatchList`).pipe(
      catchError((error: any) => {
        this.notificationService.showServiceError(error);
        return observableThrowError(error);
      }),
    );
  }

  addWatchList(data: any): Observable<any> {
    return this.apiGatewayService.post(`${this.gbmAPI}AddWatchList`, data).pipe(
      catchError((error: any) => {
        return observableThrowError(error);
      }),
      take(1),
    );
  }

  renameWatchList(data: any): Observable<any> {
    return this.apiGatewayService
      .post(`${this.gbmAPI}UpdateUserWatchList`, data)
      .pipe(
        catchError((error: any) => {
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  addIssueWatchList(issueId: string, watchlistType: number): Observable<any> {
    return this.apiGatewayService
      .get(`${this.gbmAPI}AddIssueWatchList/${issueId}/${watchlistType}`)
      .pipe(
        catchError((error: any) => {
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  deleteIssueWatchList(
    issueId: string,
    watchlistType: number,
  ): Observable<any> {
    return this.apiGatewayService
      .get(`${this.gbmAPI}DeleteIssueWatchList/${issueId}/${watchlistType}`)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
      );
  }

  deleteWatchList(watchlistId: number): Observable<any> {
    return this.apiGatewayService
      .get(`${this.gbmAPI}DeleteWatchList/?watchlistId=${watchlistId}`)
      .pipe(
        catchError((error: any) => {
          return observableThrowError(error);
        }),
        take(1),
      );
  }

  getWatchListDetail(data: any): Observable<any> {
    return this.apiGatewayService
      .post(`${this.gbmAPI}GetWatchListDetail`, data)
      .pipe(
        catchError((error: any) => {
          this.notificationService.showServiceError(error);
          return observableThrowError(error);
        }),
      );
  }

  private prepareDataWatchList(data: any[]): any[] {
    const result: any[] = [];
    if (data) {
      for (const item of data) {
        const row: WatchlistItemConfig = {
          watchlistId: item.watchListTypeId,
          watchlistName: item.title,
          configuration: item.configuration,
          watchlistEdit: false,
          issueConfig: [],
        };
        result.push(row);
      }
    }
    return result;
  }

  private prepareDataWatchListDetail(data: any[]): any[] {
    const result: any[] = [];
    if (data) {
      for (const item of data) {
        const row: any = {
          issue: item.issueID,
          watchlistId: item.watchlistType,
        };
        result.push(row);
      }
    }
    return result;
  }
}
